export const EMAIL_LENGTH = 50;
export const NAME_LENGTH = 50;
export const FIRSTNAME_LENGTH = 50;
export const CONTACT_MESSAGE_LENGTH = 8000;
export const BIC_MAX_LENGTH = 11;
export const BIC_MIN_LENGTH = 8;

export const FILE_ACCEPTED_FORMAT = ['html', 'pdf', 'jpg', 'jpeg', 'doc', 'png', 'eml', 'docx'];
export const FLASHING_TICKET_ACCEPTED_FORMAT = ['jpg', 'png', 'jpeg', 'pdf'];



// WEBPACK FOOTER //
// ./src/constants/form.js